import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
} from 'actions/actionConstants'
import { FETCH_WRAPPED, FETCH_WRAPPED_TOTALS } from 'actions/apiActionConstants'
import { apiReducerSwitch, createAppReducer } from 'lib/redux/reducerUtils'

export const initialWrappedState: App.WrappedState = {
  state: 'initial',
  data: undefined,
  error: undefined,
  totals: undefined,
}

const apiCalls = apiReducerSwitch<App.WrappedState>({
  [FETCH_WRAPPED]: {
    request: () => ({
      state: 'loading',
      data: undefined,
      error: undefined,
    }),
    success: (_, action) => ({
      state: 'done',
      data: action.data,
      error: undefined,
    }),
    failure: (_, action) => ({
      state: 'error',
      data: undefined,
      error: action.error,
    }),
  },
  [FETCH_WRAPPED_TOTALS]: {
    request: (state) => ({
      ...state,
      totals: {
        state: 'loading',
        data: undefined,
        error: undefined,
      },
    }),
    success: (state, action) => ({
      ...state,
      totals: {
        state: 'done',
        data: action.data,
        error: undefined,
      },
    }),
    failure: (state, action) => ({
      ...state,
      totals: {
        state: 'error',
        data: undefined,
        error: action.error,
      },
    }),
  },
})

const wrappedReducer = createAppReducer<App.WrappedState>(initialWrappedState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
})

export default wrappedReducer
